import { ErrorPage } from 'admin';
import { initAnalytics } from 'analytics';
import { QueryClient, QueryClientProvider } from 'api';
import { initMonitoring } from 'monitor';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { dateAdapter, LocalizationProvider, ThemeProvider } from 'ui';

import { App } from './App';

const reactAppRoot = document.getElementById('react-app-id');

initAnalytics();
initMonitoring('internal');
const queryClient = new QueryClient();

if (reactAppRoot) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ReactDOM.createRoot(reactAppRoot!).render(
    <React.StrictMode>
      <BrowserRouter>
        <ErrorBoundary fallback={<ErrorPage href="https://app.safi.co/ground-control/" />}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <LocalizationProvider dateAdapter={dateAdapter} adapterLocale="en-gb">
                <App />
              </LocalizationProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>
  );
}
